import { createSlice } from '@reduxjs/toolkit'

const stateSlice = createSlice({
    name: 'area/state',
    initialState: {
        deleteConfirmation: false,
        selectedArea: [],
        sortedColumn: () => {},
    },
    reducers: {
        toggleDeleteConfirmation: (state, action) => {
            state.deleteConfirmation = action.payload
        },
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setSelectedArea: (state, action) => {
            state.selectedArea = action.payload
        },
    },
})

export const { 
    toggleDeleteConfirmation, 
    setSortedColumn,
    setSelectedArea
} = stateSlice.actions

export default stateSlice.reducer
